import type WebRTCClient from './WebRTCClient';
import type { Calls } from '../types';
import { CallSignalingType } from '../types/enums';

export default class WebRTCSignalingProcessor {
  public delegate: WebRTCClient;

  constructor(delegate: WebRTCClient) {
    this.delegate = delegate;
  }

  public onMessage = (userID: number, extension: Calls.ExtensionParams): void => {
    const sessionId = extension?.sessionID ?? '';
    const signalType = extension?.signalType;
    /** cleanup */
    delete extension?.moduleIdentifier;
    delete extension?.sessionID;
    delete extension?.signalType;

    switch (signalType) {
      case CallSignalingType.CALL:
        this.delegate.onCallHandler(userID, sessionId, extension);
        break;
      case CallSignalingType.ACCEPT:
        this.delegate.onAcceptHandler(userID, sessionId, extension);
        break;
      case CallSignalingType.REJECT:
        this.delegate.onRejectHandler(userID, sessionId, extension);
        break;
      case CallSignalingType.STOP:
        this.delegate.onStopHandler(userID, sessionId, extension);
        break;
      case CallSignalingType.CANDIDATE:
        this.delegate.onIceCandidatesHandler(userID, sessionId, extension);
        break;
      case CallSignalingType.RESTART:
        this.delegate.onIceRestartHandler(userID, sessionId, extension);
        break;
      case CallSignalingType.RESTART_ACCEPT:
        this.delegate.onIceRestartAcceptHandler(userID, sessionId, extension);
        break;
    }
  };
}
